import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import {
    getUniqueTokenizationTypeIDs,
    MultiTokenizationTypeBadge,
    TokenizationTypeBadge,
} from "~/components/TokenizationTypeBadge";
import { AssetTableRowData, TokenRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const TOKENIZATION_TYPE_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    label: (
        <>
            Tokenization
            <br />
            Type
        </>
    ),
    slug: AssetColumns.tokenizationTypeIDs,
    sortsOn: AssetColumns.tokenizationTypeIDs,
    tooltip: CatalogReferenceDataSlugs.tokenization_type,
    type: ColumnTypes.string,
    width: 160,
    renderOptions: {
        fullWidth: true,
    },
    render: (item, { renderOptions }) => {
        const { fullWidth = true } = renderOptions ?? {};

        const className = fullWidth
            ? "w-full flex justify-center items-center"
            : undefined;

        if (item.isAsset) {
            const tokens = item.tokens;

            // Get unique tokenization type IDs
            const tokenizationTypeIDs = getUniqueTokenizationTypeIDs(tokens);

            // Return Emdash if no tokenization type IDs
            if (tokenizationTypeIDs.length === 0) {
                return <Emdash />;
            }

            // If there's only one tokenization type ID, return the badge
            if (tokenizationTypeIDs.length === 1) {
                return (
                    <TokenizationTypeBadge
                        tokenization_type_id={tokenizationTypeIDs[0]}
                        className={className}
                        size="sm"
                    />
                );
            }

            // If there are multiple tokenization type IDs, return the badges
            return (
                <MultiTokenizationTypeBadge size="sm" className={className} />
            );
        }

        const token = item as TokenRowData;
        return (
            <TokenizationTypeBadge
                tokenization_type_id={token.tokenization_type_id}
                className={className}
                size="sm"
            />
        );
    },
};
